<template>
	<table class="table table-striped">
		<thead>
		<tr>
			<th>
				{{itemName}} Name
			</th>
			<th width="200">
				Discount
			</th>
			<th width="140">
				Attributes
			</th>
			<th width="125">
				Price
			</th>
			<th width="100">
				Apply Limit
			</th>
			<th width="125">
				Net Revenue*
			</th>
		</tr>
		</thead>
		<tbody>
		<tr v-for="item in items">
			<td>
				{{item.name}}
				<div class="font-size-sm text-muted" v-if="item.venueName">{{item.venueName}}</div>
			</td>
			<td>
				<div v-if="item.attributes && item.attributes.length">
					<div class="input-group pb-1" v-for="attr in item.attributes">
						<input :type="attr.discount.type === 'formula' ? 'text' : 'number'" class="form-control" v-model="attr.discount.amount" :disabled="attr.discount.type === 'formula'" :placeholder="attr.discount.type === 'formula' ? 'f(x)' : ''">
						<div class="input-group-append">
							<button type="button" class="btn btn-primary">
								<span v-if="attr.discount.type == 'percent'">%</span>
								<span v-if="attr.discount.type == 'fixed'">{{ currencyPrefix }}</span>
								<span v-if="attr.discount.type == 'formula'">x</span>
							</button>
							<button type="button" class="btn btn-primary dropdown-toggle dropdown-toggle-split" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
								<span class="sr-only">Toggle Dropdown</span>
							</button>
							<div class="dropdown-menu" style="">
								<a class="dropdown-item" @click.prevent="typeChanged(attr.discount, 'percent')">%</a>
								<a class="dropdown-item" @click.prevent="typeChanged(attr.discount, 'fixed')">{{ currencyPrefix }}</a>
								<a class="dropdown-item" @click.prevent="typeChanged(attr.discount, 'formula')">x</a>
							</div>
						</div>
					</div>
				</div>
				<div v-else>
					<div class="input-group pb-1" >
						<input :type="item.discount.type === 'formula' ? 'text' : 'number'" class="form-control" v-model="item.discount.amount" :disabled="item.discount.type === 'formula'" :placeholder="item.discount.type === 'formula' ? 'f(x)' : ''">
						<div class="input-group-append">
							<button type="button" class="btn btn-primary">
								<span v-if="item.discount.type == 'percent'">%</span>
								<span v-if="item.discount.type == 'fixed'">{{ currencyPrefix }}</span>
								<span v-if="item.discount.type == 'formula'">x</span>
							</button>
							<button type="button" class="btn btn-primary dropdown-toggle dropdown-toggle-split" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
								<span class="sr-only">Toggle Dropdown</span>
							</button>
							<div class="dropdown-menu" style="">
								<a class="dropdown-item" @click.prevent="typeChanged(item.discount, 'percent')">%</a>
								<a class="dropdown-item" @click.prevent="typeChanged(item.discount, 'fixed')">{{ currencyPrefix }}</a>
								<a class="dropdown-item" @click.prevent="typeChanged(item.discount, 'formula')">x</a>
							</div>
						</div>
					</div>
				</div>
			</td>
			<td class="pt-3">
				<div v-if="item.attributes && item.attributes.length">
					<div v-for="attr in item.attributes">
						<p class="mb-3">{{attr.name}}</p>
					</div>
				</div>
			</td>
			<td class="pt-3">
				<div v-if="item.attributes && item.attributes.length">
					<div v-for="attr in item.attributes">
						<p class="mb-3" v-html="getPrice(attr.offer_price, attr.discount)"></p>
					</div>
				</div>
				<div v-else>
					<p class="mb-3" v-html="getPrice(item.offer_price, item.discount)"></p>
				</div>
			</td>
			<td>
				<div v-if="item.attributes && item.attributes.length">
					<div v-for="attr in item.attributes">
						<input type="number" class="input-mini form-control mb-1" v-model="attr.discount.limit">
					</div>
				</div>
				<div v-else>
					<input type="number" class="input-mini limit form-control" v-model="item.discount.limit">
				</div>
			</td>
			<td>
				<div v-if="item.attributes && item.attributes.length">
					<div v-for="attr in item.attributes">
						<input type="number" class="input-mini form-control mb-1" v-model="attr.discount.revenue">
					</div>
				</div>
				<div v-else>
					<input type="number" class="input-mini limit form-control" v-model="item.discount.revenue">
				</div>
			</td>
		</tr>
		</tbody>
	</table>
</template>

<script>
export default {
    props: {
        items: Array,
		  itemName: String,
        timezone: String,
        currencyPrefix: String,
        moment: require('moment'),
    },
    components: {

    },
    methods: {
		typeChanged(discount, type) {
			discount.type = type;
			this.$forceUpdate();
		},
		getPrice: function(amount, discount) {
			var price = '';

			if( discount.amount > 0 ) {
			    price += '<s>'+this.currencyPrefix+amount+'</s> ';

			    if( discount.type === 'percent' ) {
			        var offerPrice = Math.max(amount * ((100 - discount.amount)/100), 0);
			    }else if ( discount.type === 'fixed' ) {
			        var offerPrice = Math.max(amount - discount.amount, 0);
			    }

			    price += this.currencyPrefix+accounting.formatMoney(offerPrice, { format: "%v" });
			}else{
			    price += this.currencyPrefix+amount;
			}

			return price;
		},
		fixDiscount: function(discount) {
			if( !discount ) return;

			if( discount.type !== 'formula' )
				discount.amount = parseFloat(discount.amount);

			discount.revenue = parseFloat(discount.revenue);
			discount.limit = parseFloat(discount.limit);
		},
		mounted() {
			this.items.forEach((item) => {
				if( item.attributes && item.attributes.length ) {
					item.attributes.forEach((attr) => {
						this.fixDiscount(attr.discount);
					});
				} else {
					this.fixDiscount(item.discount);
				}
			});
		},
    },
}
</script>